import OnlineHomeworkResult from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, 0];
  return [key, val];
};

const create = (data) =>
  new OnlineHomeworkResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/OnlineHomeworkResult/create.js